<section class="flex h-full flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
  @if (hasAccommodation) {
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center gap-2">
        <h3 class="text-primary-900">
          {{ "calculator.accommodation" | transloco }}
        </h3>
      </div>
      <p-button
        [label]="'calculator.addAccommodation' | transloco"
        variant="outlined"
        (onClick)="addAccommodation()"
        icon="pi pi-plus"
      />
    </div>

    @for (
      entry of tripService.sortedAccommodations();
      track entry.originalIndex
    ) {
      <article class="flex flex-col gap-4 rounded-lg bg-white p-4">
        <div class="flex flex-1 flex-col gap-1">
          <div class="flex flex-1 flex-row items-center justify-between">
            <div class="flex flex-col">
              <div class="flex flex-row items-center gap-3">
                <div class="paragraph-med text-primary-950">
                  {{
                    entry.item.title ??
                      entry.item.customEmissionFactor?.name ??
                      (entry.item.type
                        ? ("categoryType." + entry.item.type | transloco)
                        : "")
                  }}
                </div>
                <app-item-validation-badge
                  class="ml-2"
                  scope="accommodation"
                  [index]="entry.originalIndex"
                  (badgeClick)="onItemValidationBadgeClick($event)"
                />
                @if (entry.item.isEcoFriendly) {
                  <div
                    class="rounded-lg bg-primary-100 px-2 py-1 text-primary-700"
                  >
                    {{ "calculator.placeholder.ecoFriendly" | transloco }}
                  </div>
                }
              </div>
              <div class="text-paragraph-xs-reg text-greyscale-700">
                @if (entry.item.type) {
                  <span
                    >{{ "categoryType." + entry.item.type | transloco }} -
                  </span>
                }
                <span>{{
                  countryService.getCountryLabelByLang(entry.item.countries)
                }}</span>
              </div>
            </div>

            <div class="justify-end">
              <p-button
                icon="pi pi-ellipsis-v"
                (click)="op.toggle($event)"
                rounded
                variant="text"
                size="small"
              ></p-button>
              <p-popover #op>
                <div class="flex flex-col">
                  <p-button
                    icon="pi pi-pencil"
                    [label]="'edit' | transloco"
                    variant="text"
                    (onClick)="editAccommodation(entry.originalIndex)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [label]="'delete' | transloco"
                    variant="text"
                    severity="danger"
                    (onClick)="confirmDelete(entry.originalIndex)"
                  />
                </div>
              </p-popover>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-1">
          @if (displayPeoplePerRoomOrAccommodation(entry.item)) {
            <div class="flex flex-row items-center">
              <span class="mr-1 text-paragraph-s-med text-greyscale-600"
                >{{
                  ((displayPerRoom(entry.item)
                    ? "calculator.label.peoplePerRoom"
                    : "calculator.label.peoplePerAccommodation"
                  ) | transloco) + " :"
                }} </span
              ><span class="text-paragraph-s-med text-greyscale-900">
                {{ entry.item.peoplePerRoom }}
                {{
                  (entry.item.peoplePerRoom > 1
                    ? "travelBoards.people"
                    : "travelBoards.person"
                  ) | transloco
                }}</span
              >
            </div>
          }
          <div class="flex flex-row">
            <span class="mr-1 text-paragraph-s-med text-greyscale-600">{{
              ("calculator.placeholder.nights" | transloco) + " :"
            }}</span
            ><span class="text-paragraph-s-med text-greyscale-900"
              >{{ entry.item.nights }}
              {{
                (entry.item.nights > 1
                  ? "prestations.nights"
                  : "prestations.night"
                ) | transloco
              }}</span
            >
          </div>
        </div>
        @if ((entry.item.scheduledDays?.length ?? 0) > 0) {
          <div class="w-full border border-greyscale-100"></div>
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-paragraph-s-med text-greyscale-600">{{
              "tripDashboard.scheduledOn" | transloco
            }}</span>
            @for (day of entry.item.scheduledDays; track $index) {
              <span
                class="rounded-xl bg-gray-100 p-1 px-2 text-paragraph-xs-reg text-greyscale-900"
                >{{ ("travelBoards.day" | transloco) + " " + day }}</span
              >
            }
          </div>
        }
      </article>
    }
  } @else {
    <app-prestation-empty-state
      [title]="'calculator.emptyState.accommodation.title' | transloco"
      [text]="'calculator.emptyState.accommodation.text' | transloco"
      [buttonLabel]="'calculator.addAccommodation' | transloco"
      [action]="addAccommodation"
    />
  }
</section>
